<main>
    <div class="container main-panel">
        <app-header-ad [position]="'top'"></app-header-ad>
        <app-breadcrumbs *ngIf="breadcrumbs" [breadcrumbs]="breadcrumbs" class="padding-left-20"></app-breadcrumbs>
        <br>
        <div style="margin-right: 10px; margin-left: 10px">
            <div *ngIf="showTopics" class="article-inner-container">
                <h1>Lawshelf Short Videos - Presentations on a broad range of legal topics <i *ngIf="!shortVideos"
                        style="color: #337ab7; font-weight: 800; font-size: 22px; margin-left: 20px"
                        class="fa fa-spinner fa-spin"></i></h1>
                <hr />

                <div class="row">
                    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 nav-panel-wrap">
                        <a style="background-image: url('/assets/img/blog-img.png');"
                            class="panel nav-panel courseware-panel mylazy" [routerLink]="['/blogview']">
                            <div class="panel-text-wrap">
                                <h2>Law in the News</h2>
                            </div>
                            <div class="nav-panel-bkgd"></div>
                        </a>
                    </div>

                    <div *ngFor="let video of shortVideos" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 nav-panel-wrap">
                        <app-display-topic [area]="topicArea" [topic]="video"></app-display-topic>
                    </div>
                </div>
            </div>
            <span *ngIf="currentTopic && showContentEntries">
                <div class="row">
                    <div *ngFor="let contentEntry of currentTopic.contentEntries"
                        class="col-lg-4 col-md-6 col-sm-12 nav-panel-wrap">
                        <app-display-content-entry [area]="contentArea" [selectedTopic]="currentTopic"
                            [contentEntry]="contentEntry"></app-display-content-entry>
                    </div>
                </div>
            </span>
        </div>
        <app-header-ad [position]="'bottom'"></app-header-ad>
    </div>
</main>